<template>
  <div>
    <!-- 设置数字人形象 -->
    <div class="digitalHumanAppearanceContainer">
      <div class="videoContainer">
        <div
          class="videoImgBox"
          :style="{
            backgroundImage: `url(${videoBg})`,
          }"
        >
          <el-image class="videoImg" :src="otherParams.aiImage"></el-image>
        </div>
      </div>
      <div class="videoBgSelectContainer">
        <div class="title">视频背景选择</div>
        <div class="videoBgContainer">
          <div class="videoBg">
            <el-image
              class="videoBgImg"
              :src="otherParams.defaultBg"
            ></el-image>
            <div class="radioContainer" @click="otherParams.isDefaultBg = true">
              <div
                class="radio"
                :class="{ active: otherParams.isDefaultBg }"
              ></div>
              <div class="text">默认</div>
            </div>
          </div>
          <div class="videoBg">
            <div class="videoBgImg">
              <upload-image
                @success="formVal.backgroundImageUrl = $event"
                :value="formVal.backgroundImageUrl"
                :type="formVal.resolution"
              />
            </div>
            <div
              class="radioContainer"
              @click="otherParams.isDefaultBg = false"
            >
              <div
                class="radio"
                :class="{ active: !otherParams.isDefaultBg }"
              ></div>
              <div class="text">
                <span>自定义</span>
                <span class="subText">
                  支持PNG,JPG，5M以内的图片，图片比例为9:16 自定义
                  建议使用AI软件生成，如豆包的图像生成功能。跳转地址</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="audioSelectContainer">
          <div class="title">播报内容</div>
          <el-button type="primary" class="btn" v-if="otherParams.textType ==1" @click="openAiWrite"
            >AI推广文案生产</el-button
          >
          <div class="audioTypeContainer">
            <div class="radioContainer" @click="handleTextTypeChange(1)">
              <div
                class="radio"
                :class="{ active: otherParams.textType === 1 }"
              ></div>
              <div class="text">文字播报</div>
            </div>
            <div class="radioContainer" @click="handleTextTypeChange(2)">
              <div
                class="radio"
                :class="{ active: otherParams.textType === 2 }"
              ></div>
              <div class="text">音频播报</div>
            </div>
          </div>
          <div class="audioTextContainer">
            <div class="audioIptBox" v-if="otherParams.textType === 1">
              <el-input
                v-model="formVal.text"
                class="audioText"
                placeholder="请输入介绍内容"
                type="textarea"
                :rows="18"
                maxlength="1000"
              ></el-input>
              <div class="textLength">{{ formVal.text.length }}/1000</div>
            </div>
            <div v-else>
              <upload-audio
                @success="handleUploadAudioSuccess"
                :value="{ url: formVal.url, name: otherParams.audioFileName }"
              />
            </div>
          </div>
        </div>
        <div class="audioSpeedContainer">
          <div class="title">播报语速</div>
          <div class="speedBox">
            <div
              @click="formVal.speechRate = item.value"
              v-for="(item, index) in speedRange"
              :key="index"
              class="speedContainer"
            >
              <div
                class="speedDot"
                :class="{ active: formVal.speechRate === item.value }"
              ></div>
              <div class="speedText">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="audioSubtitleContainer">
          <div class="title">字幕设置</div>
          <div class="switchContainer">
            <el-switch
              v-model="formVal.subtitleEmbedded"
              :disabled="otherParams.textType === 2"
            ></el-switch>
            <div>是否显示字幕</div>
          </div>
          <el-form
            :inline="true"
            v-if="formVal.subtitleEmbedded"
            class="fontContainer"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="字体">
                  <el-select v-model="formVal.subtitleName">
                    <el-option
                      label="阿里巴巴普惠体"
                      value="alibabapuhuiti"
                    ></el-option>
                  </el-select> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item label="字号">
                  <el-select v-model="formVal.subtitleSize">
                    <el-option
                      v-for="(_, index) in 37"
                      :key="index"
                      :label="index + 36"
                      :value="index + 36"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="字体颜色">
                  <el-color-picker v-model="formVal.subtitleColor" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="字体描边">
                  <el-color-picker v-model="formVal.subtitleOutlineColor" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="buttonContainer">
      <el-button type="primary" plain @click="handlePrev">上一步</el-button>
      <el-button type="primary" @click="handleOpenConfirmModal"
        >保存并生成视频</el-button
      >
    </div>
    <!-- 确认弹窗 -->
    <ConfirmModal
      ref="confirmModalRef"
      @draft="handleDraft"
      @save="handleSave"
    />
    <writeAi ref="writeAiRef" @useAiWrite="useAiWrite" />
  </div>
</template>
<script>
import UploadImage from "./uploadImage";
import UploadAudio from "./uploadAudio";
import ConfirmModal from "./confirmModal";
import { saveTodraft, videoQueue } from "@/assets/api/aiProduct";
import writeAi from "../../components/writeAi.vue";
export default {
  components: {
    UploadImage,
    UploadAudio,
    ConfirmModal,
    writeAi,
  },
  props: {
    // 数字人code
    defaultFormVal: "",
    // 其他参数
    defaultOtherParams: "",
  },
  data() {
    return {
      formVal: {
        // 数字人code
        code: "",
        // 数字人背景图片
        backgroundImageUrl: "",
        // （注：3D视频全支持，2D视频只支持3、4）
        // 生成视频分辨率，生成的视频分辨率必须要与背景图片的分辨率保持一致
        //  目前支持：
        // 1：720 * 1280（竖屏）2：1280 * 720（横屏）3：1080 * 1920（竖屏）4：1920 * 1080（横屏）
        resolution: 3,
        // 字幕
        subtitleEmbedded: false,
        // 字体颜色，十六进制颜色码 RGBA。(subtitleEmbedded为true时，此字段必传)
        subtitleColor: "",
        // 字体名称(subtitleEmbedded为true时，此字段必传)
        subtitleName: "",
        // 字体描边颜色，十六进制颜色码 RGBA。(subtitleEmbedded为true时，此字段必传)
        subtitleOutlineColor: "",
        // 字体大小，最小值：36，最大值：72，默认值：36。(subtitleEmbedded为true时，此字段必传)
        subtitleSize: 36,
        // 任务类型，1 表示 3D 数字人视频合成，3 表示 2D 数字人视频合成
        taskType: 3,
        // (音频合成视频时，此字段必传)音频的地址 url，要求音频时长小于 30 分钟，采样率 16K，单声道，单采样点位深 16bit 可访问的公网url地址
        // 音频文件url
        url: "",
        // 播报内容，最长不超过 1000 个字符
        text: "",
        // 播报语速，
        // 取值范围：-500～500，[-500, 0, 500]
        // 对应的语速倍速区间为 [0.5, 1.0, 2.0]计算方法如下：
        // 0.8 倍速（1-1/0.8)/0.002 = -1251.2 倍速（1-1/1.2)/0.001 = 166
        speechRate: 0,
      },
      otherParams: {
        // 默认背景图
        defaultBg:
          "https://image2.soole.com.cn/slb-picture2025051316363046226.jpg",
        // 是否默认
        isDefaultBg: true,
        // 播报内容 文字 1  音频 2
        textType: 1,
        // ai 数字人的形象
        aiImage: "",
        // 播报文件filename
        audioFileName: "",
      },
      // 播报语速范围计算
      speedRange: [
        { label: "0.5", value: this.getSpeed(0.5) },
        { label: "0.75", value: this.getSpeed(0.75) },
        { label: "正常", value: 0 },
        { label: "1.25", value: this.getSpeed(1.25) },
        { label: "1.5", value: this.getSpeed(1.5) },
        { label: "2", value: this.getSpeed(2) },
      ],
    };
  },
  watch: {
    defaultFormVal: {
      handler(newVal) {
        this.formVal = newVal || this.formVal;
        this.otherParams = this.defaultOtherParams || this.otherParams;
      },
      immediate: true,
    },
  },
  /** ai数字人背后展示的图片 */

  computed: {
    videoBg() {
      if (this.otherParams.isDefaultBg) {
        return this.otherParams.defaultBg;
      }
      return this.formVal.backgroundImageUrl || this.otherParams.defaultBg;
    },
  },
  methods: {
    // 打开AI生成弹窗
    openAiWrite() {
      this.$refs.writeAiRef.open();
    },
    // 使用AI文案
    useAiWrite(text) {
      this.formVal.text = text;
    },
    /**
     * 计算播报语速
     * 例如  0.8 倍速（1-1/0.8)/0.002 = -125
     *  1.2 倍速（1-1/1.2)/0.001 = 166
     * @param val 语速
     */
    getSpeed(val) {
      if (val < 1) {
        return Math.floor((1 - 1 / val) / 0.002);
      }
      return Math.floor((1 - 1 / val) / 0.001);
    },
    /**
     * 播报内容切换 音频文件没有字幕
     * @param val 1 文字 2 音频
     */
    handleTextTypeChange(val) {
      if (this.formVal.url && val == 1)
        return this.$message.warning("文字和音频播报只可选择一种！");
      if (this.formVal.text && val == 2)
        return this.$message.warning("文字和音频播报只可选择一种！");
      this.otherParams.textType = val;
      // 音频文件没有字幕
      this.formVal.subtitleEmbedded =
        val === 2 ? false : this.formVal.subtitleEmbedded;
    },
    /** 返回上一页 */
    handlePrev() {
      this.$emit("prev", this.formVal, this.otherParams);
    },
    getSubmitData() {
      return {
        ...this.formVal,
        subtitleColor: this.formVal.subtitleEmbedded
          ? this.hexToArgb(this.formVal.subtitleColor)
          : "",
        subtitleOutlineColor: this.formVal.subtitleEmbedded
          ? this.hexToArgb(this.formVal.subtitleOutlineColor)
          : "",
        bizId: +this.$route.query.id,
        bizType: 2,
      };
    },
    /** 保存草稿 */
    handleDraft() {
      // requestId =
      this.formVal.text = this.formVal.text.replace(/\s+/g, " ");
      const data = this.getSubmitData();
      saveTodraft({
        ...data,
      }).then((res) => {
        if (res.code === "200") {
          this.$emit("save", {
            type: "draft",
            value: this.formVal,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /** 保存 */
    handleSave() {
      this.formVal.text = this.formVal.text.replace(/\s+/g, " ");
      const data = this.getSubmitData();
      // 生成视频
      videoQueue({
        ...data,
      }).then((res) => {
        if (res.code === "200") {
          this.$emit("save", {
            type: "publish",
            value: this.formVal,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 上传音频成功
     */
    handleUploadAudioSuccess(data) {
      this.formVal.url = data.url;
      this.otherParams.audioFileName = data.name;
    },

    handleOpenConfirmModal() {
      // 去除回车
      const txt = this.formVal.text;
      this.formVal.text = txt.replace(/\s+/g, " ");
      if (this.otherParams.isDefaultBg) {
        this.formVal.backgroundImageUrl = this.otherParams.defaultBg;
      } else {
        console.log(this.formVal);

        if (!this.formVal.backgroundImageUrl) {
          this.$message.error("请上传自定义背景图");
          return;
        }
      }
      if (this.otherParams.textType === 1) {
        if (!this.formVal.text.trim()) {
          this.$message.error("请输入播报文字");
          return;
        }
      } else {
        if (!this.formVal.url) {
          this.$message.error("请上传播报音频文件");
          return;
        }
      }
      if (this.formVal.subtitleEmbedded) {
        if (!this.formVal.subtitleName) {
          this.$message.error("请选择字体名称");
          return;
        } else if (!this.formVal.subtitleSize) {
          this.$message.error("请选择字体大小");
          return;
        } else if (!this.formVal.subtitleColor) {
          this.$message.error("请选择字体颜色");
          return;
        } else if (!this.formVal.subtitleOutlineColor) {
          this.$message.error("请选择字体描边");
          return;
        }
      }
      this.$refs.confirmModalRef.open();
    },

    /**
     * 颜色转换
     * @param hex 16进制颜色
     * @param alpha 透明度
     * @returns
     */
    hexToArgb(hex) {
      // 去掉前面的 #
      hex = hex.replace(/^#/, "");

      // 解析红、绿、蓝分量
      const r = hex.slice(0, 2);
      const g = hex.slice(2, 4);
      const b = hex.slice(4, 6);

      // 设置 alpha 分量为 FF (完全不透明)
      const a = "FF";

      // 返回 ARGB 格式
      return `#${r}${g}${b}${a}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonContainer {
  margin-left: 263px;
}

.digitalHumanAppearanceContainer {
  display: flex;
  gap: 162px;
  margin-bottom: 20px;

  .title {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: 600;
  }

  .radioContainer {
    cursor: pointer;
    display: flex;
    gap: 8px;

    .radio {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid rgba(172, 178, 195, 1);
      position: relative;

      &::after {
        display: none;
        content: "";
        background-color: rgba(21, 104, 235, 1);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0;
        bottom: 0;
        margin: auto;
      }

      &.active {
        border: 1px solid rgba(21, 104, 235, 1);

        &::after {
          display: block;
        }
      }
    }

    .text {
      flex: 1;
      font-size: 14px;
      color: rgba(0, 0, 0, 1);
      display: flex;

      .subText {
        color: rgba(172, 178, 195, 1);
        font-size: 12px;
        margin-left: 8px;
        flex: 1;
      }
    }
  }

  .videoContainer {
    width: 784px;
    height: 813px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(172, 178, 195, 0.2);

    .videoImgBox {
      width: 375px;
      height: 667px;
      background-size: 100% 100%;

      .videoImg {
        width: 375px;
        height: 667px;
      }
    }
  }

  .videoBgSelectContainer {
    .videoBgContainer {
      margin-bottom: 40px;
      display: flex;
      gap: 64px;
      margin-top: 19px;

      .videoBg {
        display: flex;
        flex-direction: column;
        gap: 26px;

        .videoBgImg {
          width: 120px;
          height: 213px;
        }
      }
    }
  }

  .audioSelectContainer {
    margin-bottom: 40px;
    position: relative;
    .btn {
      position: absolute;
      top: 20pox;
      right: 0;
    }

    .audioTypeContainer {
      margin-top: 20px;
      display: flex;
      gap: 26px;
    }

    .audioTextContainer {
      margin-top: 12px;

      .audioIptBox {
        position: relative;

        .textLength {
          position: absolute;
          right: 20px;
          bottom: 10px;
        }
      }

      .audioText ::v-deep .el-textarea__inner {
        background-color: rgba(172, 178, 195, 0.1) !important;
        padding-bottom: 20px !important;
      }
    }
  }

  .audioSpeedContainer {
    margin-bottom: 40px;

    .speedBox {
      margin-top: 20px;
      width: 400px;
      height: 6px;
      background-color: #d0e1fb;
      border-radius: 6px;
      position: relative;
      z-index: 1;

      .speedContainer {
        position: absolute;
        display: flex;
        flex-direction: column;
        gap: 6px;
        z-index: 2;
        top: -5px;

        &:first-child {
          left: 7px;
        }

        &:nth-child(2) {
          left: 81px;
        }

        &:nth-child(3) {
          left: 160px;
        }

        &:nth-child(4) {
          left: 238px;
        }

        &:nth-child(5) {
          left: 313px;
        }

        &:nth-child(6) {
          left: 377px;
        }

        .speedDot {
          cursor: pointer;
          background-color: #d0e1fb;
          width: 16px;
          height: 16px;
          border-radius: 50%;

          &.active {
            background-color: #1568eb;
          }
        }

        .speedText {
          font-size: 14px;
        }
      }
    }
  }

  .audioSubtitleContainer {
    .switchContainer {
      margin-top: 20px;
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .fontContainer {
      margin-top: 12px;
    }
  }
}
</style>
